interface IGetCategoryList {
  regex: RegExp;
  parent: string;
  category: string;
}
/*
  Where to add the obj ? 
  includedRegexList: The object will be picked for page view event through _app.tsx
  excludedRegexList: page view event to be called explicitly
*/

export const includedRegexList = [
  { regex: /.*\/webinars\/?$/, parent: 'webinars', category: 'all' },
  { regex: /.*\/ifsc-code.*\/?/, parent: 'ifsc-code', category: '' },
  { regex: /.*\/glossary.*\/?/, parent: 'glossary', category: '' },
  { regex: /.*\/gst-hsn.+\/?/, parent: 'gst', category: 'hsn' },
  { regex: /.*\/gst-.+\/?/, parent: 'gst', category: '' },
  { regex: /.*\/.+-calculator\/?$/, parent: 'calculator', category: '' },
  { regex: /.*\/rewards\/?$/, parent: 'rewards', category: '' },
  { regex: /.*\/authors\/?.*$/, parent: 'authors', category: '' },
  { regex: /.*\/(www.)?clear.tech\/?$/, parent: 'clear_tech', category: '' },
  { regex: /.*\/(www.)?clear.in\/?$/, parent: 'clear_homepage', category: '' },
  { regex: /.*\/itr-2-filing\/?.*$/, parent: 'itr-2-filing', category: '' },
  {
    regex: /.*\/itr-filing-for-traders\/?.*$/,
    parent: 'itr-filing-for-traders-investors',
    category: '',
  },
  {
    regex: /.*\/itr-filing-for-esop-and-rsu\/?.*$/,
    parent: 'itr-filing-for-esop-and-rsu ',
    category: '',
  },
  {
    regex: /.*\/itr-filing-for-nri-and-foreign-income\/?.*$/,
    parent: 'itr-filing-for-nri-and-foreign-income',
    category: '',
  },
  {
    regex: /.*\/itr-filing-for-business-income\/?.*$/,
    parent: 'itr-filing-for-business-income',
    category: '',
  },
];

export const excludedRegexList = [
  { regex: /.*\/partner-.+\/?$/, parent: 'partner', category: '' },
  { regex: /.*\/webinars\/.+/, parent: 'webinars', category: '' },
  { regex: /.*\/pricing\/.*$/, parent: 'mp_pricing', category: '' },
  { regex: /.*\/pricing-paid\/.*$/, parent: 'mp_pricing', category: '' },
  { regex: /.*\/\[?partner\]?$/, parent: 'partner', category: '' },
  { regex: /^.*\/s\/(?!partner-).*$/, parent: 'content', category: '' },
  { regex: /\/sa\//, parent: 'sa_content', category: '' },
  { regex: /^$/, parent: 'uncategorized', category: '' },
  { regex: /^$/, parent: 'crypto', category: '' },
];

type getCategoryNameType = {
  regexList?: Array<IGetCategoryList>;
  pageType?: string;
  parent?: boolean;
  url?: string;
};
/*
  regexList?: use either or both of the exported regexList
  pageType?: for CMS pages
  parent?: true ? return parent category : child category
  url?: specify url
*/
export const getCategoryName = ({
  regexList = includedRegexList,
  pageType = '',
  parent = false,
  url,
}: getCategoryNameType): string | undefined | null => {
  if (pageType && pageType === 'CMS') return 'uncategorized';

  if (typeof window !== 'undefined') {
    try {
      if (sessionStorage.getItem('/s/pricing')) {
        return sessionStorage.getItem('/s/pricing');
      }
    } catch (e) {
      // SecurityError in iOS Safari private mode - continue with regex matching
    }
  }

  const categoryObj = regexList.find((getCategory) => {
    return getCategory.regex.test(url || window.location.href);
  });

  if (!categoryObj) return undefined;
  return parent ? categoryObj?.parent : categoryObj?.category;
};

const categoryList = {
  stocks: { parentCategory: 'stocks', subCategory: '' },
  goldRate: { parentCategory: 'gold-rate', subCategory: '' },
  silverRate: { parentCategory: 'silver-rate', subCategory: '' },
  currency: {
    parentCategory: 'currency-converter',
    subCategory: 'currency-converter',
  },
  indices: {
    parentCategory: 'indices',
    subCategory: '',
  },
  uncategorized: {
    parentCategory: 'uncategorized',
    subCategory: 'uncategorized',
  },
};

export const getPageCategory = (
  url: string | undefined
): { parentCategory: string; subCategory: string } => {
  if (!url) return categoryList.uncategorized;

  const categories = [
    { path: '/stocks', category: categoryList.stocks },
    { path: '/gold-rate', category: categoryList.goldRate },
    { path: '/silver-rate', category: categoryList.silverRate },
    { path: '/currency-converter', category: categoryList.currency },
    { path: '/indices', category: categoryList.indices },
  ];
  const matchedCategory = categories.find((cat) => url.includes(cat.path));

  return matchedCategory
    ? matchedCategory.category
    : categoryList.uncategorized;
};
